
export class GrmEvent {
    #isRunEvent = false;
    #eventQueue = [];
    #eventListenersMap = {};

    constructor() {

    }

    addEventListener(type, listener, options) {
        let list = this.#eventListenersMap[type];
        if(!list){
            this.#eventListenersMap[type] = list = [];
        }
        list.push({
            listener, options
        });
        return this;
    }

    removeEventListener(type, listener) {
        let list = this.#eventListenersMap[type];
        if(!list){
            return this;
        }

        if(!listener){
            delete this.#eventListenersMap[type];
            return this;
        }

        for(let i=0; i<list.length; i++){
            if(list[i].listener !== listener){
                continue;
            }
            list.splice(i, 1);
            break;
        }

        return this;
    }

    trigger(type, data) {
        let e = null;
        if(typeof type === 'object'){
            e = type;
            type = e.type;
        }

        let list = this.#eventListenersMap[type];
        if(!list){
            // console.warn('unknown event :', type, data);
            return this;
        }

        if(!e){
            e = {
                type,
                data,
                eventTime: new Date()
            };
        }

        let works;
        for(let i=0; i<list.length; i++){
            let obj = list[i];
            let rt = obj.listener(e);
            if(rt instanceof Promise){
                if(!works) works = [];
                works.push(rt);
            }

            if(obj.options && obj.options.once){
                list.splice(i, 1);
                i--;
            }
        }

        if(works){
            return Promise.all(works);
        }
        return Promise.resolve();
    }

    async pushEvent(event, data) {
        if(typeof event === 'string'){
            event = {
                type: event,
                data
            };
        }

        this.#eventQueue.push(event);
        await this._runEvent()
    }

    async _runEvent() {
        if(!this.#isRunEvent) return;

        let event;
        while(
            (event = this.#eventQueue.shift())
        ){
            return this.trigger(event);
        }
    }

    pauseEvent() {
        this.#isRunEvent = false;
        return this;
    }

    async runEvent() {
        this.#isRunEvent = true;
        await this._runEvent();
        return this;
    }
}

export const grmEvent = new GrmEvent();